/*
* @Author: zhangzhitao
* @Date: 2019-06-10 15:06:23
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-06-21 17:01:30
*/

<template>
  <div
    class="m-main-container"
    :class="{'edu-style':widthType===1}"
  >
    <el-scrollbar
      wrap-class="m-wrap-class"
      view-class="m-view-class"
    >
      <div
        class="m-water-fall"
        :class="{'media-container':widthType===1}"
      >
        <div
          v-for="(part, i) in arrParts"
          :key="i"
          :name="i"
        >
          <component :is="part.mode"></component>
        </div>
        <!-- <mps-service
          :componentSet="['portal.bs.waterfall']"
          @message-get="onMessageGet"
        ></mps-service> -->
      </div>
    </el-scrollbar>
    <!--  -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'water-fall',
  props: {
    overdueFlag: {
      type: Boolean,
      default: false
    },
    arrList: {
      type: Array,
      default: () => {
        return []
      }
    },
    widthType: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      arrParts: []
    }
  },
  async created () {
    for (let i = 0; i < this.arrList.length; i++) {
      await this.handlePushWidget(this.arrList[i])
    }
  },
  methods: {
    // 将拖拽的部件数据置入编辑区内
    handlePushWidget (widget) {
      return new Promise(async (resolve, reject) => {
        let part = JSON.parse(JSON.stringify(widget))
        let Fn = Function
        let res = await axios.get(part.url)
        let mode = new Fn(`return ${res.data}`)()
        part['mode'] = mode.__esModule ? mode.default : mode
        this.arrParts.push(part)
        resolve()
      })
    },
    // websocket消息推送
    onMessageGet (data) {
      let params = {
        sourceId: 'portal',
        destId: data.widgetId,
        msgType: 'waterfall',
        data: data.data
      }
      this.$root.$emit(`${data.widgetId}_waterfall`, params)
    }
  },

  watch: {
    arrList: {
      handler () {
        this.arrList.forEach(widget => {
          this.handlePushWidget(widget)
        })
      },
      deep: true
    }
  }
}

</script>

<style lang="scss" scoped>
$type: screen;
$max: max-width;
$min: min-width;
$value1: 1760px;
$value2: 1480px;
.m-main-container {
  width: 100%;
  height: 100%;
  &.edu-style {
    ::v-deep .m-view-class {
      background: url(../../../assets/images/jx_head.png);
      background-repeat: no-repeat;
      background-position: center top;
      background-size: contain;
      background-color: #f5f5f5;
    }
  }
  ::v-deep .m-wrap-class {
    position: absolute !important;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
  .m-water-fall {
    width: 100%;
    margin: 0 auto;
    &.media-container {
      width: 1720px;
      min-height: 472px;
      @media #{$type} and ($max: $value1) and ($min: $value2) {
        width: calc(100% - 40px);
      }
      @media #{$type} and ($max: $value2) {
        width: 100%;
      }
    }
  }
}
</style>
